module.exports = __webpack_public_path__ + "static/media/success-activation.e5b2599b.png";